import React, { useEffect, Fragment } from "react";
import {Link} from 'react-router-dom';
import {ArrowUpRight, ChevronLeft, ChevronRight, Grid} from 'react-feather';


// Import Assets
import godaddy from '../../assets/images/godaddy-single-service-banner.png';

const Godaddy = (props) => {

    // Adding custom class to body 
    useEffect(() =>{
        props.location.pathname === '/' ? document.body.classList.add("home-class") : document.body.classList.add("custom-class");
    })

    return (
        <Fragment>
            <section id="single-project-wrapper">
                <div className="single-project">
                    <div className="container-fluid">
                        <div className="w-full">
                            <div className="single-project-image">
                                <img className="object-cover h-max w-screen" src={godaddy} alt="Featured" />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="max-w-default w-default px-12 py-28 lg:py-24 md:py-16 sm:py-4 container-wrapper">
                            <div className="single-project-details">
                                <div className='breadcrumbs pb-4'>
                                    <li><Link to='/'>Home</Link> <span>{'>'}</span> <Link to='/our-work'>Our Work</Link><span>{'>'}</span><Link to='/godaddy-india' className='current'>GoDaddy India</Link></li>
                                </div>
                                <div className="flex lg:flex-row md:flex md:flex-col sm:flex-col single-project-details-wrapper">
                                    <div className="single-project-details-left grid grid-rows-1 grid-cols-2 gap-20">
                                        <div className="details-project-name">
                                            <h3 className="heading5 pb-8">Project Name</h3>
                                            <h1>Godaddy India</h1>
                                        </div>
                                        <div>
                                            <h3 className="heading5 pb-8">Type</h3>
                                            <p>Social Media</p>
                                        </div>
                                        {/* <div>
                                            <h3 className="heading5 pb-8">Type</h3>
                                            <p>Social Media</p>
                                        </div> */}
                                        {/* <div>
                                            <h3 className="heading5 pb-8">Website</h3>
                                            <p>lorem Ipsum</p>
                                        </div> */}
                                    </div>
                                    <div className="single-project-details-right lg:pt-0 lg:py-16 md:pt-12">
                                        <div>
                                            <h2 className="heading5 pb-8">The Ask</h2>
                                            <p>Introduce and establish GoDaddy India as a primary platform for small businesses and the startup ecosystem to launch their ventures online. </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="single-project-body">
                                    <h2 className="heading4 pb-8">What we did</h2>
                                    <p>We collaborated with MS Dhoni, who played the avatar of #BijnessBhai to encourage business owners to bring their businesses online. This helped make the brand feel more at home for potential Indian prospects and penetrate the tier 2 and tier 3 markets. We promoted our discount offers, and meetups for GoDaddy pro members and communicated our offerings on social media. To reach relevant prospects and stakeholders, we came up with ad sets to target web-savvy audiences, entrepreneurs, and the fanbase aspect of the brand GoDaddy.</p>
                                    
                                </div>

                                <h2 className="heading4 pt-16 pb-8 what-campaign-achived godaddy">
                                    What the campaign achieved
                                </h2>
                                <div className="results">
                                    <div>
                                        <h1>8.3 Crore</h1>
                                        <h2>Video Views</h2>
                                    </div>
                                    <div>
                                        <h1>12 Lac+</h1>
                                        <h2>Engagements</h2>
                                    </div>
                                </div>

                                <div className="pagination">
                                    <div><Link to='/spectra-draw-the-line'><ChevronLeft/><span>Previous</span></Link></div>
                                    <div><Link to='/our-work'><Grid/><span>All Projects</span></Link></div>
                                    <div><Link to='/upes-shakti'><ChevronRight/><span>Next</span></Link></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Footer CTA Ribbon */}
            <section id='take-next-leap' key='single-project'>
                <div className='take-next-leap'>
                    <div className='take-next-leap__left'>
                        <h1 className="heading4 black">Let's create <span>impact together.</span></h1>
                    </div>
                    <div className='take-next-leap__right'>
                        <p><Link to='/contact-us'>Contact us today<ArrowUpRight/></Link></p>
                    </div>
                </div>
            </section>
            {/* Footer CTA Ribbon */}
        </Fragment>
    );
};

export default Godaddy;